import React, { useCallback, useContext, useEffect, useState } from 'react'

import { useTranslation } from 'react-i18next'
import LanguageInputSection from '../../components/SelectLanguage'

import { DomainContext } from '../../domain-repository/DomainRepository'

import { saveLocalStorageTranslations } from '../../i18n'

import { getLanguages, getLocalizations } from '../../services/localizations'

export function transformLocalsArrayToObject(array) {
  return array
    .reduce((prev, curr) => ({ ...prev, [curr.key]: curr.value }), {})
}

export function mapLocalizations(lang, defaultLang, values) {
  const ids = {};
  const keyValues = [];
  for (const row of values) {
    if (!ids[row.id]) {
      ids[row.id] = true;
      const found = row.entries.find(r => r.lang === lang) || row.entries.find(r => r.lang === defaultLang) || row.entries[0];
      keyValues.push({
        key: row.key,
        type: row.type,
        description: row.description,
        pageId: row.pageId,
        lang: found.lang,
        value: found.value,
      });
    }
  }
  return keyValues
}

export function SelectLanguagePage(props) {
  const { i18n } = useTranslation()

  const [isLoading, setIsLoading] = useState(false)

  const [defaultLang, setDefaultLang] = useState('en')
  const [languages, setLanguages] = useState([])

  const handleLanguageChange = useCallback(() => {
    props.history.push('/select-pickup-details')
  }, [])

  return (
    <LanguageInputSection
      onChange={handleLanguageChange}
      handleLogoClick={() => props.history.push('/start')}
    />
  )
}

export default SelectLanguagePage